import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import IInput from './models/input';
import IOutput from './models/output';
export const getLearningCircleList = (data: IInput): Promise<IOutput> => {
    const url = data.is_join ? Api.JOIN_CIRCLE_LIST : Api.MANAGE_CIRCLE_LIST;
    const param = {
        to_umu_id: data.umu_id,
        size: data.size,
        page: data.page,
        is_hidden: data.is_hidden,
    };
    return fetchData(url, param).then((res: IOutput) => {
        return res;
    });
};

export const getCourseList = (data: IInput): Promise<IOutput> => {
    const url = data.is_join ? Api.JOIN_COURSE_LIST : Api.MANAGE_COURSE_LIST;
    const param = {
        to_umu_id: data.umu_id,
        size: data.size,
        page: data.page,
        is_hidden: data.is_hidden,
    };
    return fetchData(url, param).then((res: IOutput) => {
        return res;
    });
};
export type IOutputC = IOutput;
